import type { JSX } from 'react';

type SVGProps = { name: string; fillColor: string; strokeColor: string };

export const SocialMediaSvg = ({
  name,
  fillColor: fill,
  strokeColor: stroke,
}: SVGProps): JSX.Element => {
  const fillStyle = {
    fill,
  };

  const strokeStyle = {
    stroke,
  };

  const iconPaths = {
    linkedinUrl: (
      <path
        style={fillStyle}
        d="M23.633 23.633h-2.37V19.92c0-.885-.017-2.025-1.234-2.025-1.235 0-1.424.965-1.424 1.96v3.778h-2.37v-7.635h2.276v1.043h.031a2.495 2.495 0 0 1 2.246-1.233c2.403 0 2.846 1.58 2.846 3.637l-.001 4.188ZM13.56 14.954a1.376 1.376 0 1 1 0-2.752 1.376 1.376 0 0 1 0 2.752Zm1.185 8.68h-2.373v-7.636h2.373v7.635ZM24.815 10H11.18A1.167 1.167 0 0 0 10 11.154v13.691A1.168 1.168 0 0 0 11.18 26h13.635A1.17 1.17 0 0 0 26 24.845V11.153A1.17 1.17 0 0 0 24.815 10"
      />
    ),
    facebookUrl: (
      <>
        <g clipPath="url(#a)">
          <path
            style={fillStyle}
            d="M24.545 10h-13.09a1.428 1.428 0 0 0-1.03.434 1.485 1.485 0 0 0-.425 1.05v13.352c0 .82.65 1.484 1.455 1.484h7.272v-6.676h-2.182v-2.226h2.182v-1.195c0-2.263 1.081-3.255 2.924-3.255.884 0 1.35.066 1.572.096v2.129h-1.258c-.782 0-1.056.421-1.056 1.274v.951h2.294l-.311 2.226h-1.983v6.676h3.636a1.428 1.428 0 0 0 1.03-.434 1.485 1.485 0 0 0 .425-1.05V11.484a1.51 1.51 0 0 0-.426-1.05A1.454 1.454 0 0 0 24.545 10Z"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path
              fill="#fff"
              d="M10 9h16v17H10z"
            />
          </clipPath>
        </defs>
      </>
    ),
    instagramUrl: (
      <path
        style={fillStyle}
        d="M14.687 10.056c-.851.04-1.433.176-1.94.376-.527.205-.973.48-1.416.925a3.92 3.92 0 0 0-.92 1.418c-.197.51-.33 1.09-.368 1.943-.038.851-.046 1.125-.042 3.297.004 2.173.014 2.445.055 3.299.04.85.176 1.432.376 1.94.205.526.48.972.925 1.415.445.444.891.717 1.419.92.509.197 1.09.331 1.942.368.852.038 1.126.046 3.298.042 2.172-.004 2.445-.014 3.298-.054.854-.04 1.432-.177 1.94-.376.526-.205.972-.48 1.415-.925a3.92 3.92 0 0 0 .92-1.419c.197-.509.331-1.09.368-1.942.037-.853.046-1.126.042-3.298-.004-2.172-.014-2.445-.054-3.298-.041-.853-.177-1.432-.376-1.94a3.928 3.928 0 0 0-.925-1.416 3.905 3.905 0 0 0-1.419-.92c-.509-.197-1.09-.331-1.942-.368-.852-.037-1.126-.046-3.298-.042-2.173.004-2.445.014-3.298.055Zm.093 14.462c-.78-.034-1.203-.163-1.486-.272a2.491 2.491 0 0 1-.92-.596 2.467 2.467 0 0 1-.6-.92c-.11-.281-.242-.704-.279-1.484-.04-.843-.048-1.097-.053-3.232-.004-2.136.004-2.389.04-3.232.034-.78.165-1.204.273-1.486.144-.374.317-.64.596-.921a2.47 2.47 0 0 1 .92-.6c.281-.11.704-.241 1.484-.278.844-.04 1.096-.048 3.232-.053 2.136-.005 2.389.003 3.233.04.78.035 1.204.164 1.485.273.374.144.64.317.921.596.281.28.455.545.6.92.111.28.242.704.279 1.484.04.843.049 1.096.053 3.232.004 2.135-.004 2.389-.04 3.232-.035.78-.164 1.203-.273 1.486a2.48 2.48 0 0 1-.597.92c-.28.282-.545.455-.919.6-.281.11-.705.242-1.484.28-.844.039-1.096.047-3.233.052-2.136.004-2.388-.004-3.232-.04m6.522-10.794a.96.96 0 1 0 1.92-.004.96.96 0 0 0-1.92.004Zm-7.41 4.283a4.107 4.107 0 1 0 8.215-.016 4.107 4.107 0 0 0-8.215.016Zm1.441-.003a2.666 2.666 0 1 1 5.333-.01 2.666 2.666 0 0 1-5.333.01Z"
      />
    ),
    xUrl: (
      <>
        <g clipPath="url(#a)">
          <path
            style={fillStyle}
            d="M22.594 11h2.442l-5.333 6.367L26 26h-4.948l-3.855-5.233L12.763 26h-2.442l5.72-6.8L10 11h5.076l3.502 4.8 4.016-4.8Zm-.867 13.467h1.35l-8.74-12.034H12.86l8.868 12.034Z"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path
              fill="transparent"
              d="M10 11h16v15H10z"
            />
          </clipPath>
        </defs>
      </>
    ),
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      fill="none"
    >
      <rect
        width="35"
        height="35"
        x=".5"
        y=".5"
        fill="transparent"
        rx="17.5"
      />
      <rect
        width="35"
        height="35"
        x=".5"
        y=".5"
        style={strokeStyle}
        rx="17.5"
      />
      {iconPaths[name]}
    </svg>
  );
};
